import React from 'react';

import { Box, Typography } from '@mui/joy';

export interface MetricBoxProps {
  label: string;
  value: string | number;
  color?: 'normal' | 'warning' | 'danger';
  onClick?: () => void;
}

const getBgColor = (color: 'normal' | 'warning' | 'danger'): string => {
  switch (color) {
    case 'warning':
      return 'warning.800';
    case 'danger':
      return 'danger.800';
    default:
      return 'neutral.700';
  }
};

const MetricBox: React.FC<MetricBoxProps> = ({ label, value, color = 'normal', onClick }) => (
  <Box onClick={onClick} className='p-2 rounded cursor-pointer select-none' sx={{ bgcolor: getBgColor(color) }}>
    <Typography level='body-xs' className='uppercase'>
      {label}
    </Typography>
    <Typography level='body-sm' className='font-mono'>
      {value}
    </Typography>
  </Box>
);

export default MetricBox;
